import { render, staticRenderFns } from "./physicianFeeScheduleList.vue?vue&type=template&id=4bf6c1a9&"
import script from "./physicianFeeScheduleList.vue?vue&type=script&lang=js&"
export * from "./physicianFeeScheduleList.vue?vue&type=script&lang=js&"
import style0 from "./physicianFeeScheduleList.vue?vue&type=style&index=0&slot-scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports